import {
  getMenuCategories,
  getMenuDetail,
  getMenus,
  postPreSignedUrl,
  updateMenusInfo,
  updateMenuSort,
  updateMenuStatus,
  updateMenuThumbnail
} from 'apis';
import { useMutation, useQuery, useQueryClient } from 'react-query';

type UpdateParam = { sid: string; data: unknown };

export const useMenuCategories = (sid: string | undefined) => {
  return useQuery(['getMenuCategories'], () => getMenuCategories(sid), {
    enabled: !!sid
  });
};

export const useMenus = (sid: string | undefined, params?: unknown) => {
  return useQuery(['getMenus', sid, params], () => getMenus(sid, params), {
    enabled: !!sid
  });
};

export const useMenuDetail = (sid: string | undefined, menuId: string) => {
  return useQuery(['getMenuDetail', menuId], () => getMenuDetail(sid, menuId), {
    enabled: !!sid && !!menuId
  });
};

export const useUpdateMenu = () => {
  return useMutation(['updateMenuStatus'], (params: UpdateParam) => {
    const { sid, data } = params;
    return updateMenuStatus(sid, data);
  });
};

export const useUpdateMenusInfo = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ['updateMenusInfo'],
    (params: { sid: string; params: unknown }) => updateMenusInfo(params.sid, params.params),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('getMenus');
      }
    }
  );
};

export const useUpdateMenuThumbnail = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ['updateMenuThumbnail'],
    ({ sid, params }: { sid: string; params: any }) => updateMenuThumbnail(sid, params),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('getMenus');
      }
    }
  );
};

export const useUpdateMenuSort = () => {
  return useMutation(['updateMenuSort'], ({ sid, params }: { sid: string; params: any }) => updateMenuSort(sid, params));
};

export const usePostPreSignedUrl = () => {
  return useMutation(['postPreSignedUrl'], (params: unknown) => postPreSignedUrl(params));
};
